import { render } from "./PointChargeManageView.vue?vue&type=template&id=e5c5a906"
import script from "./PointChargeManageView.vue?vue&type=script&lang=js"
export * from "./PointChargeManageView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__